export default __webpack_public_path__ + "static/media/googleIcon.7e66a6bc.svg";